module.exports = __webpack_public_path__ + "img/slash-circle-02.0238d704.svg";